<template>
  <div class="body signinbody">
    <div class="heightcontainer">
      <div class="d-block d-lg-none">
        <nav
            class="sign-in-navheight navbar navbar-expand-lg navbar-expand-sm navbar-expand-md navbar-expand-xl navbar-fixed-top"
          >
            <div class="col pl-0 d-flex">
              <div class="col-6 mr-auto my-auto ml-md-2">
                <router-link to="/" tag="a">
                  <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>
                </router-link>
              </div>
              <div>
                <span class="fontsize56 proximanova-thin black businesstext">Recruiter</span>
              </div>
            </div>
          </nav>
      </div>
      <div class="">
        <div class="row no-gutters">
          <div class="col-lg-4 p-4 d-none d-lg-block signinleftcard sign-in-background">
              <div class="col-12 pl-4 d-flex flex-column">
                <div class="col-lg-6 pl-0 pr-0 d-flex flex-column mt-lg-5 mb-5">
                  <router-link to="/" tag="a">
                    <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>
                  </router-link>
                  <span class="proximanova-thin fontsize48 black pb-4">Recruiter</span>
                </div>
                <span class="proximanova-bold fontsize32 black mt-5">Join Worknotion</span>
                <span class="proximanova-light fontsize32 black">world’s Best</span>
                <span class="">
                  <span class="proximanova-bold fontsize32 black">Video Professional</span> <span class="ml-2 proximanova-light fontsize32 black">Community</span>
                </span>
              </div>
              <div class="copyright col-lg-12 pb-5 col-sm-12 col-md-12">
                <div class="col-12 pr-4 d-flex flex-column justify-content-between">
                  <div class="d-flex pointer mt-3">
                    <img src="../assets/HelpSignin.svg" alt="help">
                    <span class="proximanova pointer fontsize12 black ml-2 my-auto">Help</span>
                  </div>
                  <div>
                    <span class="proximanova fontsize12 black60"> <span class="fontsize16">&#169;</span> 2022 Worknotion. All rights reserved</span>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-lg-8 pb-5 backgroundcolorwhite">
            <div class="col-12 mx-auto mr-0">
              <div class="card-body text-center mb-2 p-0 p-md-4">
                <div class="d-flex flex-column mt-2">
                  <span class="proximanova-semibold fontsize28 black logintext">Sign Up</span>
                  <span class="proximanova fontsize14 black60 text-nowrap mt-3">What do you want to use from worknotion.com</span>
                </div>
                <div class="mt-4">
                    <span class="proximanova-semibold fontsize24 black logintext">Continue to signup as...</span>
                    <div class="col-12 mt-4 d-flex justify-content-between">
                      <div class="prodcards p-2 pointer borderblack602 borderradius20" @click="navToSignInPages('user')">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-5">
                            <img src="../assets/signin_job.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 black proximanova-semibold text-nowrap mt-1 ml-md-2">Professional</span>
                          </div>
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          Connect, Collaborate, Share interests and Knowledge with diverse people, apply to various jobs and build a strong network globally.
                        </div>
                      </div>
                      <div class="prodcards p-2 pointer borderblack602 borderradius20" @click="navToSignInPages('company')">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-4">
                            <img src="../assets/signin_company.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 black text-nowrap proximanova-semibold mt-1 ml-md-2">Company</span>
                          </div>
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          Upon creating a Company account, you will have your business page and profile and can start building value for your brand.
                        </div>
                      </div>
                      <div class="p-2 prodcards pointer borderblue3 borderradius20">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-4">
                            <img src="../assets/signin_people_blue.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 blue text-nowrap proximanova-semibold mt-1 ml-md-2">Recruiter</span>
                          </div>
                          <img src="../assets/blueTickMark.svg" width="15" class="tickmark mt-0 mr-1" alt="selected">
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          Registering for a recruiter account will help you post unlimited jobs free of cost and hire candidates that suit your criteria directly.
                        </div>
                      </div>
                    </div>
                  </div>
                <div :hidden="getotpdetails">
                  <div class="mt-5 text-center">
                    <h2 class="verify-your-email-id proximanova d-flex flex-column">
                      <span class="fontsize24 proximnanova black">Verify Your Business Email ID</span>
                    </h2>
                    <div class="alert-danger red">{{emailverifymessage}}</div>
                  </div>
                  <div class="form-group form mt-2 col-12 col-md-8 col-lg-6 mx-auto">
                    <div class="mt-4">
                      <div class="col-12 d-flex justify-content-start align-items-center ">
                        <div class="input-group mb-3">
                          <div class="col-12 p-1 d-flex inputborder">
                            <div class="col">
                              <img src="../assets/Email _ Phone.svg" alt="email"/>
                            </div>
                            <input type="email"
                              name="Email"
                              id="inputemail"
                              v-validate="'required'"
                              class="signininput col-10 proximanova"
                              placeholder="John@abc.com"
                              v-model="emailId"
                              data-vv-as="Email"
                              required>
                          </div>
                          <div
                            v-if="errors.has('Email')"
                            class="alert-danger ml-5"
                          >The Email Id must be a valid email</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 text-left pr-4">
                      <span class="fontsize14 black proximanova mt-3"
                      >By Clicking Get OTP you are agreed to the Worknotion</span>
                    </div>

                    <div class="col-12 text-left pr-4">
                      <span class="proximanova blue fontsize12 mt-2">
                        <a :href="wndata.termsandConditions" target="_blank" rel="noopener noreferrer" class="proximanova pointer">Terms & Conditions</a>, 
                        <a :href="wndata.privacypolicy" target="_blank" rel="noopener noreferrer" class="proximanova pointer">Privacy & Policies</a>
                      </span>
                    </div>

                    <div class="">
                      <div class="col mt-4">
                        <button
                          type="button"
                          class="btn btn-light btn-sm w-100 p-2 text-center sign-up-button proximanova blackbackhroundsignin borderradius20"
                          id="getotpbutton"
                          @click="checkemail"
                          :disabled="loadinganimation"
                        >Get OTP <img src="../assets/loginload.svg" v-if="loadinganimation" width="27px" alt="loginload"></button>
                      </div>
                    </div>
                  </div>
                </div>
              <!-- Email verificationdetails -->
              <div :hidden="verificationdetails">
                <div class="col mt-md-4 mt-1">
                  <img src="../assets/OTP_Illustrations.svg" class="mx-auto d-block" alt="img"/>
                </div>
                <div class="row no-gutters mt-md-3">
                  <div class="col otptext mr-5 proximanova text-center">{{otpmessage}} {{this.emailId}}</div>
                </div>
                <div class="d-flex justify-content-center">
                  <div class="mt-3 ml-2">
                    <div class="col-12 p-1  d-flex inputborder">
                      <input type="text"
                        v-validate=" 'required' "
                        v-model="otp"
                        @keyup="verifyotp()"
                        class="signininput fontsize24 col-12 proximanova text-center"
                        name="OTP"
                        placeholder="Enter OTP"
                        data-vv-as="OTP"
                        maxlength="6">
                    </div>
                    <div
                      v-if="errors.has('OTP')"
                      class="col alert-danger ml-4"
                    >{{ errors.first('OTP') }}</div>
                    <span class="fontsize14 proximanova red">{{message}}</span>
                  </div>
                </div>

                <div class="col text-center mt-4 mb-4">
                  <div @click="getresendotp()">
                    <label class="pointer blue fontsize16 proximanova">Re - send OTP</label>
                  </div>
                </div>
              </div>
              <!-- CREATE PASSWORD -->
              <div :hidden="emailidverification">
                <div class="mr-0 mt-4 text-center">
                  <h2 class="verify-your-email-id proximanova">Email Id Verified.</h2>
                </div>
                <div class="text-center proximanova">
                  <h4>Create Password</h4>
                </div>
                <div class="form mt-2 col-12 col-md-8 col-lg-6 mx-auto">
                  <div class="mt-4">
                    <div class="input-group text-center">
                      <div class="col-12 p-1 d-flex inputborder">
                          <div class="col">
                            <img src="../assets/Password_Icon.svg" alt="password"/>
                          </div>
                          <input :type="type1"
                            name="npwd"
                            @input="checkpassword()"
                            placeholder="Add NewPassword"
                            class="signininput col-9 proximanova"
                            v-validate=" 'required' "
                            v-model="newpassword"
                            maxlength="16"
                            data-vv-as="password"
                            required>
                            <div class="col mt-1">
                              <span><img v-if="showpassword1" alt="show" class="pointer" @click="toggleimage1" id="viewpassword" src="../assets/ViewPassword_Dissabled.svg"/></span>
                              <img v-if="!showpassword1" alt="hide" class="pointer" @click="toggleimage1" id="viewpassword" src="../assets/ViewPassword.svg"/>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div>
                      <div
                        v-if="errors.has('npwd')"
                        class="alert-danger"
                      >{{ errors.first('npwd') }}</div>
                      <div class="alert-danger">{{this.passmessage}}</div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="input-group">
                      <div class="col-12 p-1 d-flex inputborder">
                          <div class="col">
                            <img src="../assets/Password_Icon.svg" alt="password"/>
                          </div>
                          <input :type="type2"
                            name="rpwd"
                            placeholder="Confirm New Password"
                            class="signininput col-9 proximanova"
                            v-validate="'required'"
                            ref="newpassword"
                            @keyup="checkconfirmpassword()"
                            v-model="cpassword"
                            maxlength="16"
                            data-vv-as="confirm Password"
                            required>
                            <div class="col mt-1">
                              <span><img v-if="showpassword2" alt="show" class="pointer" @click="toggleimage2" id="viewpassword" src="../assets/ViewPassword_Dissabled.svg"/></span>
                              <img v-if="!showpassword2" alt="hide" class="pointer" @click="toggleimage2" id="viewpassword" src="../assets/ViewPassword.svg"/>
                            </div>
                        </div>
                    </div>
                    <br />

                    <div
                      v-if="errors.has('rpwd')"
                      class="alert-danger mt-2"
                    >{{ errors.first('rpwd') }}</div>
                    <div class="alert-danger mt-2">{{cpasswordmessage}}</div>
                  </div>
                  <div>
                    <div class="by-clicking-get-otp proximanova-semibold text-left pl-0 col-11 mt-3">Password requirements : </div>
                    <div class="d-flex mt-1 ml-2">
                      <img src="../assets/password_check1.png" width="20" height="18" alt="valid" v-if="passwordLengthValid">
                      <img src="../assets/password_cross.png" width="18" height="18" alt="invalid" v-else>
                      <div class="fontsize13 proximanova ml-1">At least 8 to 16 character(s)</div>
                    </div>
                    <div class="d-flex mt-1 ml-2">
                      <img src="../assets/password_check1.png" width="20" height="18" alt="valid" v-if="passwordCapitalLetterValid">
                      <img src="../assets/password_cross.png" width="18" height="18" alt="invalid" v-else>
                      <div class="fontsize13 proximanova ml-1">At least one Capital letter [A-Z]</div>
                    </div>
                    <div class="d-flex mt-1 ml-2">
                      <img src="../assets/password_check1.png" width="20" height="18" alt="valid" v-if="passwordNumberValid">
                      <img src="../assets/password_cross.png" width="18" height="18" alt="invalid" v-else>
                      <div class="fontsize13 proximanova ml-1">At least one Number [0-9]</div>
                    </div>
                    <div class="d-flex mt-1 ml-2">
                      <img src="../assets/password_check1.png" width="20" height="18" alt="valid" v-if="passwordSpecialCharValid">
                      <img src="../assets/password_cross.png" width="18" height="18" alt="invalid" v-else>
                      <div class="fontsize13 proximanova ml-1">At least one Special character [!@#$%^&* etc]</div>
                    </div>
                  </div>
                  <div class="form-groups columnlogin mb-3 mt-3 mt-md-5">
                    <button
                      type="button"
                      id="createpassword"
                      class="btn btn-light btn-sm w-100 p-2 text-center sign-up-button proximanova borderradius20 blackbackhroundsignin"
                      @click="createpassword()"
                      :disabled="enable"
                    >Create <img src="../assets/loginload.svg" v-if="loadinganimation" width="27px" alt="loginload"></button>
                  </div>
                </div>
              </div>
              <div class="mx-auto mt-2 pb-5">
                <span class="proximanova fontsize14 black text-nowrap">Do you have an account ?</span>
                <span class="proximanova-semibold fontsize14 blue ml-2 text-nowrap pointer" @click="NavToSignIn">Sign In</span>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
  </div>
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import htttpsignup from "@/js/http-userdetails.js";
import APIerrorModal from '../components/APIerrorpopup.vue'
import { bus } from "@/main.js";
import router from '../router';
import wndata from '../js/wn_data.json'
import {mapMutations} from 'vuex'
export default {
  components: {
    BottomFooter,
    APIerrorModal
  },
  data() {
    return {
      displayAPIerrorModal : false,
      minutes: 5,
      seconds: 0,
      counter: 300,
      hidesubmitbutton: false,
      emailIdList: [],
      userdata: [],
      emailId: "",
      otp: "",
      type1: "password",
      type2: "password",
      otpmessage: "Enter OTP sent to your Registered Email ID",
      newpassword: "Enter New Password",
      confirmpassword: "Enter Confirm Password *",
      cpasswordmessage: "",
      newpassword: "",
      cpassword: "",
      show: false,
      passmessage: "",
      signup: "Candidate",
      verificationdetails: true,
      showpassword1: true,
      showpassword2: true,
      terms: false,
      message: "",
      emailverifymessage: "",
      saved: false,
      passwordLengthValid : false,
      passwordNumberValid : false,
      passwordCapitalLetterValid : false,
      passwordSpecialCharValid : false,
      getotpdetails: false,
      emailidverification: true,
      loadinganimation : false,
      emailIdLists: [],
      otpupdate: "",
      user: "CANDIDATE",
      termsConditionsVersionValue : null,
      privacyPolicyVersionValue : null,
      enable: true,
      showimage: "../assets/ViewPassword.svg",
      currentRoute : '',
      wndata : {},
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  methods: {
    ...mapMutations([
        'fetchPrivacyPolicyUpdated',
        'fetchTermsConditionsUpdated'
      ]),
    navToSignInPages : function(module) {
      var x = document.createElement('a')
      x.target = '_blank'
      if(module == 'user') {
        x.href = wndata.userWebappSignup
      }else if(module == 'company'){
        x.href = wndata.companySignUp
      }
      x.click()
    },
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    // this will invoke after click on password icon to display/hide the password
    toggleimage1() {
      if (this.showpassword1 == true) {
        this.type1 = "text";
        this.showpassword1 = false;
      } else {
        this.type1 = "password";
        this.showpassword1 = true;
      }
    },
    toggleimage2() {
      if (this.showpassword2 == true) {
        this.type2 = "text";
        this.showpassword2 = false;
      } else {
        this.type2 = "password";
        this.showpassword2 = true;
      }
    },
    OpenHelpcenterPDF(){
      var link=document.createElement('a');
      document.body.appendChild(link);
      link.href="./Business_help_center.pdf"
      link.target = '_blank';
      link.click();
    },
    // this willl invoke after click on login button
    // navigate to login screen
    NavToSignIn(){
      router.push({
        name : 'signin'
      })
    },
    // enable / disable submit button
    check() {
      document.getElementById("createpassword").classList.add("blackbackhroundsignin");
    },
    // this will invoke after click on password icon to display/hide the password
    toggleimage() {
      if (this.showpassword == true) {
        this.type = "text";
        this.showpassword = false;
      } else {
        this.type = "password";
        this.showpassword = true;
      }
    },
    // this will invoke while adding the password to check the password validations 
    checkpassword() {
      var format = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
      var hasNumber = /\d/;
      var hasSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (this.newpassword.length != 0) {
        if(this.newpassword.length >= 8 && this.newpassword.length <= 16) {
          this.passwordLengthValid = true;
        }else{
          this.passwordLengthValid = false;
        }
        this.passwordNumberValid = hasNumber.test(this.newpassword)
        this.passwordCapitalLetterValid = /[A-Z]/.test(this.newpassword);
        this.passwordSpecialCharValid = hasSpecialChar.test(this.newpassword)
        if (format.test(this.newpassword)) {
          // console.log("hello");
          this.passmessage = "";
          this.checkconfirmpassword()
        } else {
          // console.log("check")
          // this.passmessage =
          //   "Minimum 8 characters,1special character and 1number";
        }
      } else {
        this.passwordLengthValid = false;
        this.passmessage = "";
      }
    },
    // Email validations
    checkemail() {
      this.emailverifymessage = '';
      var format = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (this.emailId.length != 0) {
        if (format.test(this.emailId)) {
          this.getotp()
          // document
          //   .getElementById("getotpbutton")
          //   .classList.add("blackbackhroundsignin");
        } else {
          // document
          //   .getElementById("getotpbutton")
          //   .classList.remove("blackbackhroundsignin");
        }
      } else{
        this.emailverifymessage = "Please enter valid Email Id"
      } 
    },
    // this will invoke while confirming the new passowrd
    checkconfirmpassword() {
      console.log(this.newpassword)
          console.log(this.cpassword)
          console.log(this.newpassword === this.cpassword)
      if (this.newpassword && this.cpassword != "" && this.passmessage == "" && this.passwordLengthValid && this.passwordNumberValid && this.passwordCapitalLetterValid && this.passwordSpecialCharValid) {
        if (this.newpassword === this.cpassword) {
          // this.check();
          this.enable = false;
          this.cpasswordmessage = '';
        }else if (this.newpassword != this.cpassword) {
        document
          // .getElementById("createpassword")
          // .classList.remove("sign-in-button");
        this.enable = true;
        this.cpasswordmessage =
          "The new password and confirm password should be matched";
      }}
    },
    // this will invoke after click on get otp button
    getotp() {
      this.emailverifymessage = "";
      this.termsConditionsVersionValue = localStorage.getItem('termsConditionsVersion')
      this.privacyPolicyVersionValue = localStorage.getItem('privacyPolicyVersion')
      console.log("get otp privacy: ", this.privacyPolicyVersionValue)
      console.log("get otp terms : ", this.termsConditionsVersionValue)
      this.$validator.validateAll().then(() => {
        let signupdata = {
          email  :this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString(),
          module:"Recruiter"
        };
        this.loadinganimation = true;
        htttpsignup
          .post("/businessaccount/sendmailotp", signupdata)
          .then(response => {
            var status = response.data;
            console.log(JSON.stringify(response.data));
            this.loadinganimation = false;
            if (response.data.errorCode == 1006) {
              this.verificationdetails = false;
              this.getotpdetails = true;
              this.emailidverification = true;
            } else if (response.data.errorCode == 1003) {
              this.emailverifymessage = response.data.errorMessage;
              console.log("user exits");
            }else if (response.data.errorCode == 1042){
              this.emailverifymessage = response.data.errorMessage;
              console.log("user exits");
            }else{
              this.emailverifymessage = response.data.errorMessage;
            }
          })
          .catch(e => {            
            this.loadinganimation = false;
            this.displayAPIerrorModal = true;
          });
      });
    },
    // this will invoke after click on resend otp button
    getresendotp() {      
      this.getotp();
    },
    // this will invoke after entered otp
    verifyotp() {
      if (this.otp.length === 6) {
        this.emailidverified();
      }
    },
    // this will invoke after click on create button to create a password
    createpassword() {
      if (this.passmessage == "") {
        this.loadinganimation = true;
        let createpassword = {
          email : this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString(),
          passwordSalt : this.CryptoJS.AES.encrypt(this.newpassword, "seCRET").toString()          
        };
        htttpsignup.put("/businessaccount/createPwd", createpassword).then(response => {
          var status = response.data;
          console.log(response)
          console.log(JSON.stringify(response.data));
          if (response.data.errorCode == 1009) {
            console.log("res");
            this.loadinganimation = false;
            this.$store.state.showsuccessmessage = true;
            this.$router.push("/signin");
          }else{
            this.message = response.data.errorMessage;
          }
        }).catch((e)=> {
          this.loadinganimation = false;
          this.displayAPIerrorModal = true;
        });
      }
    },
    // otp verifications
    emailidverified() {
      this.message = '';
      this.$validator.validateAll().then(() => {
        let otpdata = {
          email : this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString(),
          otp : this.CryptoJS.AES.encrypt(this.otp, "seCRET").toString()          
        };

        htttpsignup
          .put("/businessaccount/verifyotp", otpdata)
          .then(response => {
            var status = response.data;
            console.log(JSON.stringify(response.data));
            if (response.data.errorCode == 1005) {
              console.log("response");
              this.message = response.data.errorMessage;
              this.verificationdetails = true;
              this.getotpdetails = true;
              this.emailidverification = false;
            } else if (response.data.errorCode == 1004) {
              console.log("testing");
              this.saved = true;
              this.message = response.data.errorMessage;
            }
          })

          .catch(e => {
            console.log("Failed: " + e);
            this.displayAPIerrorModal = true;
          });
      });
    }

  },
  mounted: function() {
    this.currentRoute = this.$router.currentRoute.name;   
    this.wndata = wndata;
    this.fetchTermsConditionsUpdated()
    this.fetchPrivacyPolicyUpdated()
  },
  computed: {
    isDisabled: function() {
      this.check();
    }
  }
};
</script>

<style scoped>
.signinbody{
  height: 100vh !important;
  background: white !important;;
}
.signinleftcard{
  height: 100vh !important;
}
.copyright{
  position: absolute;
  bottom: 0;
}
.prodcards{
  width: calc(33.33333% - 1.11111rem) !important;
  position: relative;
}
.prodcards:hover{
  border: 2px solid #007AFF !important;
}
.tickmark{
  position: absolute;
  right: 0;
}
.sign-in-color{
  color: #0078FF;
}
input[type="text"]::placeholder {
  /* Firefox, Chrome, Opera */
  font-size: 12px;
}
.card {
  /* position: absolute; */
  /* right: 0; */
  /* margin-left: 55%; */
  left: 0;
  top: 0;
  border: 1px solid #dddfe5 !important;
  border-radius: 20px !important;
  background-color: #ffffff !important;
  box-shadow: 0px 60px 60px 0px rgba(0, 23, 56, 0.1);
}
.inputborder{
  border: 1px solid black;
  border-radius: 4px;
}
.signininput{
  border: none;
  padding: 6px;
  flex: auto;
}
input::-moz-focus-inner{
  background-color: none;
}
input:focus{
  outline: none;
}
.signininput:focus{
  outline: none !important;
}
@media screen and (min-width : 770px) and (max-width : 1000px) {
  .card{
    margin:  0 auto;
    margin-top: 14% !important;
    margin-left: 20%;
  }
  .body{
    background-color: white;
  }
}
@media screen and (min-width : 600px) and (max-width : 769px) {
  .card{
    margin:  0 auto;
    margin-top: 18% !important;
    margin-left: 4%;
  }
  .body{
    background-color: white;
  }
  .businesstext{
    font-size: 32px !important;
  }
}
@media screen and (min-width : 760px) and (max-width : 768px) {
  .card{
    margin:  0 auto;
    margin-top: 10% !important;
    margin-left: 16% !important;
  }
}
@media screen and (min-width : 450px) and (max-width : 600px) {
  .body{
    background-color: white;
  }
}
@media screen and (max-width : 449px) {
  .card{
    margin:  0 auto;
    margin-top: 20% !important;
    margin-left: 4%;
  }
  .businesstext{
    font-size: 32px !important;
  }
  .logintext{
    font-size: 24px !important;
  }
  .prodcards{
    width: calc(35.33333% - 1.11111rem) !important;
  }
}
@media screen and (max-width : 380px){
  .prodcards{
    width: calc(38% - 1.11111rem) !important;
  }
}
</style>